import React, { useState } from "react";
import MedicineData from "../Addmedicine/MedicineData";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Icon } from "../admin/_adminApi";

const CaptureFingerprint = () => {
  const [showModel, setShowModel] = useState(false);

  // Function to handle verification
  const handleVerify = () => {
    setShowModel(true);
    toast.success("Verification successful!");
  };

  return (
    <>
      {showModel && (
        <div className="z-10 top-0 left-0 right-0 fixed">
          <div
            className="bg-gray-900 bg-opacity-80 h-full w-full fixed"
          ></div>
          <MedicineData setShowModel={setShowModel} />
        </div>
      )}
      <div className="ad-page">
        <div className="ad-ph">
          <div>
            <h1>Verify Fingerprint</h1>
            <p>Confirm the patient's identity before dispensing medicine.</p>
          </div>
        </div>
        <div className="ad-card ad-sect" style={{ maxWidth: 520 }}>
          <h3><span className="ic"><Icon.shield /></span>Fingerprint verification</h3>
          <p style={{ margin: "0 0 18px", fontSize: 14, color: "var(--fg-2)" }}>
            Ask the patient to place their finger on the device, then select Verify.
          </p>
          <button type="button" className="ad-btn primary" onClick={handleVerify}>
            <Icon.shield />Verify
          </button>
        </div>
      </div>
    </>
  );
};

export default CaptureFingerprint;
